import { render, staticRenderFns } from "./bookstore.vue?vue&type=template&id=579abf2e&scoped=true"
import script from "./bookstore.vue?vue&type=script&lang=js"
export * from "./bookstore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579abf2e",
  null
  
)

export default component.exports